<template>
  <div class="wan-card">
    <div class="wan-card__header">
      <span>
        <div class="wan-card__header--indicator indicator"></div>
        <div class="wan-card__header--text">{{ header }}</div>
      </span>
      <span class="edit-btn mdi mdi-border-color" @click.prevent="openModal">
      </span>
    </div>
    <div class="wan-card__container">
      <div class="wan-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.WAN_route_man.type") }}
        </div>
        <div class="text">route_man</div>
      </div>
      <div class="wan-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.WAN_route_man.server") }}
        </div>
        <div class="text">
          {{ this.dataRouteMan.multi_server + ":" + (this.dataRouteMan.server_port ? this.dataRouteMan.server_port : this.dataRouteMan.remote_ports)}}
        </div>
      </div>
      <div class="wan-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.WAN_route_man.ip_address") }}
        </div>
        <div class="text">
          {{ this.dataRouteMan.local_ip ? this.dataRouteMan.local_ip : "N/A" }}
        </div>
      </div>
      <div class="wan-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.WAN_route_man.mask") }}
        </div>
        <div class="text">{{ this.dataRouteMan.local_mask ? this.dataRouteMan.local_mask  : "N/A"}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import WanRoutManModal from "./WanRoutManModal.vue";
import ipSubnetCalculator from "ip-subnet-calculator";

export default {
  name: "WANrouteMan",
  components: {
    WanRoutManModal,
    ipSubnetCalculator,
  },
  props: {
    header: String,
    dataRouteMan: Object,
    optionsWAN: Array,
  },
  data() {
    return {
      //routeManData: [],
    };
  },
  computed: {},
  methods: {
    openModal(val) {
      var t = this.$createElement(WanRoutManModal, {
        props: {
          dataRouteMan: this.dataRouteMan,
          header: this.header,
          optionsWAN: this.optionsWAN,
        },
        on: {
          close: () => {
            this.$modal.hide("dynamic-modal");
          },
          update: (data) => {
            this.$emit("update", data);
          },
          delete: (val) => {
            this.$emit("delete", val);
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: "dynamic-modal",
        }
      );
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.wan-card {
  color: #fff;
  background: #f4f3ef;
  border-radius: 6px;
  max-width: 380px;
  width: 100%;
  margin-right: 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  border: 1px solid #ccc;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 19px;
    border-bottom: 1px solid #cecfd1;
    background: #e2ecdc;
    span {
      display: flex;
      align-items: center;
    }
    &--indicator {
      margin-right: 10px;
    }

    &--text {
      color: black;
      font-size: 13px;
    }
    &--more {
      text-transform: uppercase;
      color: gray;
      font-size: 11px;
    }
    .edit-btn {
      font-size: 22px;
      cursor: pointer;
      color: black;
    }
  }
  &__container {
    padding: 5px 19px;

    &--row {
      margin: 14px 0;
      display: flex;
      align-items: center;
      .title {
        max-width: 150px;
        font-size: 13px;
        width: 100%;
        margin-right: 10px;
        text-align: left;
        color: black;
      }
      .text {
        display: flex;
        font-size: 13px;
        color: black;
        align-items: center;
        .db-indicator {
          margin-right: 10px;
          padding: 4px 10px;
          border-radius: 2px;
          color: white;
        }
        .changes {
          color: gray;
          font-size: 13px;
          border-bottom: 1px solid gray;
          border-bottom-style: dashed;
        }
      }
    }
  }
}
</style>
